export const GTM_ID = 'GTM-WM8GLTD';
// TODO: Read from env?
// export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

export const pageview = (url: string) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'pageview',
    page: url,
  });
};
